// removed by extract-text-webpack-plugin
module.exports = {"closeButton":"ccKe7dQf4vcJX6bWzxPwQ","modal":"_3m1MWDKSDTX8alzCg6nRTt","modalOverlay":"_3oVKSuvpBWRWnJ5zgEvTqP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modalWrapper/modalWrapperComponent.scss
// module id = 681
// module chunks = 22